import { render, staticRenderFns } from "./AttributesDropdown.vue?vue&type=template&id=5b6aae98&scoped=true&"
import script from "./AttributesDropdown.vue?vue&type=script&lang=js&"
export * from "./AttributesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AttributesDropdown.vue?vue&type=style&index=0&id=5b6aae98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6aae98",
  null
  
)

export default component.exports